import { useSelector } from "@tanstack/react-store"
import { notificationTaps } from "./queue"

/**
 * True while a tap waits or is being opened. The notification stack holds
 * its popups meanwhile: what arrives with a tap is settled once the tap is opened, so
 * nothing flashes before it.
 */
export function useNotificationTapInProgress(): boolean {
	return useSelector(
		notificationTaps.store,
		(state) => state.size > 0 || state.isExecuting,
	)
}
